<div class="form-group row">
  <div class="col-form-label col-sm-6 text-sm-right">
    <label [for]="name"><ng-content select="[form-label]"></ng-content></label>
    <help-text-trigger [for]="name + '-help'" *ngIf="help"></help-text-trigger>
  </div>
  <div class="col-sm-6 mb-3">
    <div class="row-sm-6">
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text">€</span>
        </div>
        <ng-content select="[form-control-currency]"></ng-content>
      </div>
    </div>
    <div class="row-sm-6">
      <div class="showinsuredAmounterror" [mas-validation-message]="control"></div>
    </div>
  </div>
</div>
<help-text-content [id]="name + '-help'" *ngIf="help">
  <ng-content select="[form-help]"></ng-content>
</help-text-content>
